import { Box, SxProps, Theme } from '@mui/material'

import StyledWrap from 'components/StyledWrap'
import { concatToSXProp } from 'utils/style'

interface LogoProps {
  logo: string | null
  styles?: SxProps<Theme>
}

const logoStyles: SxProps = {
  maxWidth: '160px',
  maxHeight: '50px',
}

export default function Logo({ logo, styles }: LogoProps): JSX.Element | null {
  if (logo === null) {
    return null
  }

  return (
    <StyledWrap wrapCss="display: inline-flex;" elementName="Logo">
      <Box
        className="logo"
        aria-hidden
        component="img"
        sx={concatToSXProp(styles, logoStyles)}
        src={logo}
        alt="Company logo"
      />
    </StyledWrap>
  )
}
